import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import Rating from "@mui/material/Rating";
import { useParams, useNavigate } from "react-router-dom";
import { TextField, Grid, Button, Box } from "@mui/material";
import { ENTRYPOINT } from "../../helper/entrypoint";
import axios from "axios";

export const ConfirmationForm = ({ initialValues }) => {
  let { token } = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [rating, setRating] = useState(1);
  const [title, setTitle] = useState("");
  const [comment, setComment] = useState("");

  useEffect(() => {
    if (initialValues) {
      setName(initialValues.name);
      setEmail(initialValues.email);
      setRating(initialValues.rating);
      setTitle(initialValues.title);
      setComment(initialValues.comment);
    }
  }, [initialValues]);

  const getValues = () => ({
    name,
    email,
    rating,
    title,
    comment,
    verificationCode: token,
  });

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values, { setSubmitting }) => {
        axios
          .post(`${ENTRYPOINT}/public/reviews`, getValues())
          .then(function (response) {
            console.log(response);
            navigate(`/review/success`);
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function () {
            setSubmitting(false);
          });
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
      }) => (
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Rating
                    id="confirmation-title"
                    type="rating"
                    name="rating"
                    size="large"
                    precision={0.1}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={rating}
                    disabled={true}
                  />
                    <span style={{ marginLeft: 8, fontSize: '14px' }}>{Number(values.rating).toFixed(1)}</span>
                </Box>
            </Grid>
            <Grid item md={6}>
              <TextField
                id="confirmation-name"
                fullWidth
                type="text"
                name="name"
                onChange={(e) => setName(e.target.value)}
                onBlur={handleBlur}
                value={name}
                label="Name"
                variant="filled"
                disabled={isSubmitting}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                id="confirmation-email"
                fullWidth
                type="email"
                name="email"
                onChange={(e) => setEmail(e.target.value)}
                onBlur={handleBlur}
                value={email}
                label="E-Mail"
                variant="filled"
                disabled={isSubmitting}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="confirmation-title"
                fullWidth
                type="text"
                name="title"
                onChange={(e) => setTitle(e.target.value)}
                onBlur={handleBlur}
                value={title}
                label="Titel"
                variant="filled"
                disabled={isSubmitting}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="confirmation-comment"
                fullWidth
                type="text"
                name="comment"
                onChange={(e) => setComment(e.target.value)}
                onBlur={handleBlur}
                value={comment}
                label="Kommentar"
                multiline
                rows={16}
                variant="filled"
                disabled={isSubmitting}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                size={"large"}
                type="submit"
                disabled={isSubmitting}
              >
                Absenden
              </Button>
            </Grid>
          </Grid>
        </form>
      )}
    </Formik>
  );
};
